import { Box, Skeleton } from "@mui/material";

export const SkeletonDashboardRecentExams: React.FC = () => (
    <>
        {/* Skeleton Table Header */}
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr 1.6fr",
                mb: 1,
                pr: 2,
            }}
        >
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="50%" height={20} />
            <Skeleton variant="text" width="40%" height={20} />
        </Box>

        {/* Skeleton Rows */}
        <Box
            sx={{
                maxHeight: "220px",
                overflowY: "auto",
                pr: 1,
            }}
        >
            {[1, 2, 3].map((i) => (
                <Box
                    key={i}
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 1fr 1.6fr",
                        alignItems: "center",
                        py: 1.5,
                        px: 1,
                        backgroundColor: i % 2 === 0 ? "#F7F8FD" : "#FFFFFF",
                    }}
                >
                    {/* Exam Name */}
                    <Skeleton variant="text" width="80%" height={16} />

                    {/* Exam Code */}
                    <Skeleton variant="text" width="60%" height={16} />

                    {/* Score */}
                    <Skeleton variant="text" width="40%" height={16} />

                    {/* Details Button Skeleton */}
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Skeleton
                            variant="rounded"
                            width={90}
                            height={28}
                            sx={{ borderRadius: "4px" }}
                        />
                    </Box>
                </Box>
            ))}
        </Box>
    </>
);